import styled, { css } from 'styled-components';

export const Content = styled.div`
  margin-right: 5px;
  font-size: 9px;
  line-height: 1;
  height: 22px;
  width: 22px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  b {
    width: 13px;
    height: 18px;
    display: block;
    border-radius: 4px;
    background-color: #ccc;
    color: #000;
    text-align: center;
    display: flex;
    font-size: 8px;
    font-weight: bold;
    line-height: normal;
    align-items: center;
    justify-content: center;
    margin: 0 2px 0 0;
  }
  ${(props) =>
    props.$big &&
    css`
      height: 43px;
      width: 43px;
      border-radius: 10px;
      font-size: 14px;
      padding: 5px;
      b {
        font-size: 9px;
        border-radius: 10px;
        width: 32px;
        height: 100%;
        font-size: 18px;
        margin: 0;
        /* margin: 0 5px 0 0; */
      }
    `}
`;
